import { render, staticRenderFns } from "./consumableTab.vue?vue&type=template&id=32081a54&scoped=true"
import script from "./consumableTab.vue?vue&type=script&lang=js"
export * from "./consumableTab.vue?vue&type=script&lang=js"
import style0 from "./consumableTab.vue?vue&type=style&index=0&id=32081a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32081a54",
  null
  
)

export default component.exports